export const VIRTUAL_ID_JOURNAL = 'journal-activity-feed';
